export function byLatestDate(paramName) {
  return (a, b) => new Date(b[paramName]).getTime() - new Date(a[paramName]).getTime();
}
export function byEarliestDate(paramName) {
  return (a, b) => new Date(a[paramName]).getTime() - new Date(b[paramName]).getTime();
}
export function byLatestEpisode(a, b) {
  const latestA = latestEpisode(a);
  const latestB = latestEpisode(b);
  return byLatestDate("updated_at")(latestA, latestB);
}
export function latestEpisode(show) {
  const unreleasedEpisodes = show.episodes.filter((episode) => !episode.released).sort(byEarliestDate("air_date"));
  if (unreleasedEpisodes.length > 0) {
    return unreleasedEpisodes[0];
  } else {
    return null;
  }
}
export function hasAired(episode) {
  const now = new Date().getTime();
  const airDate = new Date(episode.air_date).getTime();
  return now > airDate;
}
export function notYetReleased(episode) {
  return !episode.released;
}
export function allMarked(episode) {
  return episode.staff.filter((staff) => !staff.finished).length === 0;
}
export function someMarked(episode) {
  return episode.staff.filter((staff) => staff.finished).length > 0;
}
export function deduplicateStaff(stafflist) {
  const acronymList = stafflist.map((staff) => staff.position.acronym);
  return stafflist.filter((staff, index) => {
    return acronymList.indexOf(staff.position.acronym) === index;
  });
}
function allGroupPositions(group) {
  return group.shows.flatMap((show) => show.episodes.flatMap((episode) => deduplicateStaff(episode.staff).flatMap((staff) => staff.position.acronym)));
}
function groupPositionCount(positions) {
  return positions.reduce((accumulator, currentPosition) => {
    return {
      ...accumulator,
      [currentPosition]: (accumulator[currentPosition] || 0) + 1
    };
  }, {});
}
function corePositions(positionCounts) {
  return Object.fromEntries(Object.entries(positionCounts).sort((a, b) => {
    const [_keyA, countA] = a;
    const [_keyB, countB] = b;
    return countB - countA;
  }).slice(0, 7));
}
function averagePositionIndex(group, acronym) {
  const episodePositions = group.shows.flatMap((show) => show.episodes.map((episode) => deduplicateStaff(episode.staff).flatMap((staff) => staff.position.acronym)));
  const appearances = episodePositions.filter((episode) => episode.includes(acronym));
  return appearances.map((episode) => episode.indexOf(acronym)).reduce((a, b) => a + b) / appearances.length;
}
function byAvgIndex(group) {
  return (a, b) => {
    const [acronymA] = a;
    const [acronymB] = b;
    const indexA = averagePositionIndex(group, acronymA);
    const indexB = averagePositionIndex(group, acronymB);
    return indexA - indexB;
  };
}
export function groupCorePositions(group) {
  const positions = allGroupPositions(group);
  const positionCounts = groupPositionCount(positions);
  const core = corePositions(positionCounts);
  return Object.entries(core).sort(byAvgIndex(group)).map(([key, _value]) => key);
}
//# sourceMappingURL=utils.js.map
